export const HKDSE_MATHS_MC_2018 = {
    year: 2018,
    title: "HKDSE 數學科 多項選擇題 2018 (Part 1)",
    totalQuestions: 45,
    timeLimit: 120, // minutes
    questions: [
      {
        id: "2018Q001",
        questionNumber: 1,
        question: "$\\frac{8^{2n+1}}{4^{3n+1}} =$",
        options: [
          { id: "A", text: "$1$" },
          { id: "B", text: "$2$" },
          { id: "C", text: "$2^n$" },
          { id: "D", text: "$2^{-n}$" }
        ],
        correctAnswer: "B",
        solution: "$\\frac{8^{2n+1}}{4^{3n+1}} = \\frac{(2^3)^{2n+1}}{(2^2)^{3n+1}} = \\frac{2^{6n+3}}{2^{6n+2}} = 2^{6n+3-(6n+2)} = 2^1 = 2$",
        topic: "指數",
        difficulty: "中等"
      },
      {
        id: "2018Q002",
        questionNumber: 2,
        question: "若 $\\frac{\\alpha}{1-x} = \\frac{\\beta}{x}$，則 $x =$",
        options: [
          { id: "A", text: "$\\frac{\\alpha}{\\alpha - \\beta}$" },
          { id: "B", text: "$\\frac{\\alpha}{\\alpha + \\beta}$" },
          { id: "C", text: "$\\frac{\\beta}{\\alpha - \\beta}$" },
          { id: "D", text: "$\\frac{\\beta}{\\alpha + \\beta}$" }
        ],
        correctAnswer: "A",
        solution: "$\\frac{\\alpha}{1-x} = \\frac{\\beta}{x}$\\n$\\alpha x = \\beta(1-x)$\\n$\\alpha x = \\beta - \\beta x$\\n$(\\alpha + \\beta)x = \\beta$\\n$x = \\frac{\\beta}{\\alpha + \\beta}$",
        topic: "分式方程",
        difficulty: "中等"
      },
      {
        id: "2018Q003",
        questionNumber: 3,
        question: "$h^2 - 6h - 4k^2 - 12k =$",
        options: [
          { id: "A", text: "$(h - 2k)(h - 2k + 6)$" },
          { id: "B", text: "$(h - 2k)(h + 2k + 6)$" },
          { id: "C", text: "$(h + 2k)(h - 2k - 6)$" },
          { id: "D", text: "$(h + 2k)(h + 2k - 6)$" }
        ],
        correctAnswer: "B",
        solution: "$h^2 - 6h - 4k^2 - 12k = h^2 - 6h - (4k^2 + 12k)$\\n$= h^2 - 6h - 4k(k + 3)$\\n$= (h - 2k)(h + 2k + 6)$",
        topic: "因式分解",
        difficulty: "中等"
      },
      {
        id: "2018Q004",
        questionNumber: 4,
        question: "$\\frac{1}{3x + 7} - \\frac{1}{3x - 7} =$",
        options: [
          { id: "A", text: "$\\frac{14}{49 - 9x^2}$" },
          { id: "B", text: "$\\frac{14}{9x^2 - 49}$" },
          { id: "C", text: "$\\frac{6x}{49 - 9x^2}$" },
          { id: "D", text: "$\\frac{6x}{9x^2 - 49}$" }
        ],
        correctAnswer: "B",
        solution: "$\\frac{1}{3x + 7} - \\frac{1}{3x - 7} = \\frac{(3x-7) - (3x+7)}{(3x+7)(3x-7)}$\\n$= \\frac{-14}{9x^2 - 49} = \\frac{14}{49 - 9x^2}$",
        topic: "分式運算",
        difficulty: "基礎"
      },
      {
        id: "2018Q005",
        questionNumber: 5,
        question: "下列有關 $y = 16 - (x - 6)^2$ 的圖像之敘述，何者正確？",
        options: [
          { id: "A", text: "該圖像與 $x$ 軸相交。" },
          { id: "B", text: "該圖像開口向上。" },
          { id: "C", text: "該圖像的 $y$ 截距為 $16$。" },
          { id: "D", text: "該圖像通過原點。" }
        ],
        correctAnswer: "A",
        solution: "$y = 16 - (x - 6)^2 = -(x-6)^2 + 16$\\n頂點 $(6, 16)$，開口向下\\n$y$ 截距：當 $x = 0$ 時，$y = 16 - 36 = -20$\\n與 $x$ 軸相交：$16 - (x-6)^2 = 0$\\n$(x-6)^2 = 16$\\n$x-6 = \\pm 4$\\n$x = 2$ 或 $x = 10$",
        topic: "二次函數",
        difficulty: "中等"
      },
      {
        id: "2018Q006",
        questionNumber: 6,
        question: "圖中，直線 $L_1$ 及直線 $L_2$ 的方程分別為 $3x + ay = b$ 及 $cx + y = d$。下列何者正確？\\nI. $ac < 3$\\nII. $ad < b$\\nIII. $bc < 3d$",
        options: [
          { id: "A", text: "只有 II" },
          { id: "B", text: "只有 III" },
          { id: "C", text: "只有 I 及 II" },
          { id: "D", text: "只有 I 及 III" }
        ],
        correctAnswer: "C",
        solution: "從圖像讀取：$L_1$ 的斜率 $= -\\frac{3}{a} < 0$，所以 $a > 0$\\n$L_2$ 的斜率 $= -c > 0$，所以 $c < 0$\\n$ac < 0 < 3$\\n交點在第一象限，所以 $ad < b$",
        topic: "直線方程",
        difficulty: "中等"
      },
      {
        id: "2018Q007",
        questionNumber: 7,
        question: "若 $f(x) = 3x^2 - 2x + 1$，則 $f(2m - 1) =$",
        options: [
          { id: "A", text: "$6m^2 - 4m + 2$" },
          { id: "B", text: "$6m^2 - 4m + 6$" },
          { id: "C", text: "$12m^2 - 16m + 2$" },
          { id: "D", text: "$12m^2 - 16m + 6$" }
        ],
        correctAnswer: "D",
        solution: "$f(2m - 1) = 3(2m-1)^2 - 2(2m-1) + 1$\\n$= 3(4m^2 - 4m + 1) - 4m + 2 + 1$\\n$= 12m^2 - 12m + 3 - 4m + 3$\\n$= 12m^2 - 16m + 6$",
        topic: "函數",
        difficulty: "中等"
      },
      {
        id: "2018Q008",
        questionNumber: 8,
        question: "設 $g(x) = x^8 + ax^7 + b$，其中 $a$ 及 $b$ 均為常數。若 $g(x)$ 可被 $x - 1$ 整除，求當 $g(x)$ 除以 $x + 1$ 時的餘數。",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$2a$" },
          { id: "C", text: "$-2a$" },
          { id: "D", text: "$-2a + 2$" }
        ],
        correctAnswer: "D",
        solution: "$g(1) = 0$（因可被 $x-1$ 整除）\\n$1 + a + b = 0$\\n$b = -1 - a$\\n$g(-1) = (-1)^8 + a(-1)^7 + b = 1 - a + (-1-a) = -2a$",
        topic: "多項式",
        difficulty: "中等"
      },
      {
        id: "2018Q009",
        questionNumber: 9,
        question: "存款 $$100000$，年利率 $2%$，年期 $3$ 年，複利計算，每月一結。求利息準確至最接近的元。",
        options: [
          { id: "A", text: "$$6000$" },
          { id: "B", text: "$$6121$" },
          { id: "C", text: "$$6176$" },
          { id: "D", text: "$$6178$" }
        ],
        correctAnswer: "C",
        solution: "每月利率 $= \\frac{2%}{12} = \\frac{1}{6}%$\\n期數 $= 3 \\times 12 = 36$\\n本利和 $= 100000 \\times (1 + \\frac{1}{600})^{36} \\approx 106176$\\n利息 $= 106176 - 100000 = 6176$",
        topic: "複利",
        difficulty: "中等"
      },
      {
        id: "2018Q010",
        questionNumber: 10,
        question: "設 $a, b$ 及 $c$ 均為非零的數。若 $3a = 4b$ 及 $a : c = 2 : 5$，則 $\\frac{a + 3b}{b + 3c} =$",
        options: [
          { id: "A", text: "$\\frac{5}{3}$" },
          { id: "B", text: "$\\frac{13}{33}$" },
          { id: "C", text: "$\\frac{30}{53}$" },
          { id: "D", text: "$\\frac{75}{38}$" }
        ],
        correctAnswer: "B",
        solution: "$3a = 4b$，所以 $a = \\frac{4b}{3}$\\n$a : c = 2 : 5$，所以 $c = \\frac{5a}{2} = \\frac{5}{2} \\times \\frac{4b}{3} = \\frac{10b}{3}$\\n$\\frac{a + 3b}{b + 3c} = \\frac{\\frac{4b}{3} + 3b}{b + 3(\\frac{10b}{3})} = \\frac{\\frac{13b}{3}}{11b} = \\frac{13}{33}$",
        topic: "比例",
        difficulty: "中等"
      },
      {
        id: "2018Q011",
        questionNumber: 11,
        question: "若 $w$ 隨 $u$ 的平方根正變且隨 $v$ 的平方反變，則下列何者必為常數？",
        options: [
          { id: "A", text: "$u^4 v w^2$" },
          { id: "B", text: "$u v^4 w^2$" },
          { id: "C", text: "$\\frac{v w^2}{u^4}$" },
          { id: "D", text: "$\\frac{v^4 w^2}{u}$" }
        ],
        correctAnswer: "A",
        solution: "$w = k\\frac{\\sqrt{u}}{v^2}$\\n$w^2 = k^2\\frac{u}{v^4}$\\n$u^4 v w^2 = u^4 v \\times k^2\\frac{u}{v^4} = k^2u^5v^{-3}$（非常數）\\n$u v^4 w^2 = u v^4 \\times k^2\\frac{u}{v^4} = k^2u^2$（非常數）\\n$\\frac{v w^2}{u^4} = \\frac{v}{u^4} \\times k^2\\frac{u}{v^4} = \\frac{k^2}{u^3v^3}$（非常數）\\n$\\frac{v^4 w^2}{u} = \\frac{v^4}{u} \\times k^2\\frac{u}{v^4} = k^2$（常數）",
        topic: "變分",
        difficulty: "困難"
      },
      {
        id: "2018Q012",
        questionNumber: 12,
        question: "設 $a_n$ 為某數列的第 $n$ 項。若 $a_3 = 21, a_6 = 89$ 及對任意正整數 $n, a_{n+2} = a_n + a_{n+1}$，則 $a_1 =$",
        options: [
          { id: "A", text: "$8$" },
          { id: "B", text: "$13$" },
          { id: "C", text: "$34$" },
          { id: "D", text: "$55$" }
        ],
        correctAnswer: "A",
        solution: "這是斐波那契數列：$a_{n+2} = a_n + a_{n+1}$\\n$a_3 = a_1 + a_2 = 21$\\n$a_4 = a_2 + a_3 = a_2 + 21$\\n$a_5 = a_3 + a_4 = 21 + a_2 + 21 = a_2 + 42$\\n$a_6 = a_4 + a_5 = (a_2 + 21) + (a_2 + 42) = 2a_2 + 63 = 89$\\n$2a_2 = 26$\\n$a_2 = 13$\\n$a_1 = 21 - 13 = 8$",
        topic: "數列",
        difficulty: "困難"
      },
      {
        id: "2018Q013",
        questionNumber: 13,
        question: "$\\frac{1-2x}{3} \\geq x - 3$ 或 $4x + 9 < 1$ 的解為",
        options: [
          { id: "A", text: "$x < -2$" },
          { id: "B", text: "$x > -2$" },
          { id: "C", text: "$x \\leq 2$" },
          { id: "D", text: "$x \\geq 2$" }
        ],
        correctAnswer: "A",
        solution: "$\\frac{1-2x}{3} \\geq x - 3$ 得 $1-2x \\geq 3x - 9$\\n$10 \\geq 5x$\\n$x \\leq 2$\\n$4x + 9 < 1$ 得 $4x < -8$\\n$x < -2$\\n取聯集：$x < -2$ 或 $x \\leq 2$\\n即 $x \\leq 2$",
        topic: "不等式",
        difficulty: "基礎"
      },
      {
        id: "2018Q014",
        questionNumber: 14,
        question: "圖中，$ABCDEFGH$ 為八邊形，其中所有的量度均準確至最接近的 cm。設 $x$ cm$^2$ 為該八邊形的實際面積。求 $x$ 值的範圍。",
        options: [
          { id: "A", text: "$13 < x < 23$" },
          { id: "B", text: "$13 < x < 27$" },
          { id: "C", text: "$17 < x < 23$" },
          { id: "D", text: "$17 < x < 27$" }
        ],
        correctAnswer: "D",
        solution: "從圖像讀取：八邊形的邊長為 $4$ cm、$6$ cm、$4$ cm\\n內部有 $2$ cm 的測量\\n實際面積範圍：$17 < x < 27$",
        topic: "面積",
        difficulty: "中等"
      },
      {
        id: "2018Q015",
        questionNumber: 15,
        question: "圖中，實心直立三角柱體的體積為",
        options: [
          { id: "A", text: "$544$ cm$^3$" },
          { id: "B", text: "$600$ cm$^3$" },
          { id: "C", text: "$660$ cm$^3$" },
          { id: "D", text: "$720$ cm$^3$" }
        ],
        correctAnswer: "C",
        solution: "三角柱體的底面積 $= \\frac{1}{2} \\times 17 \\times 12 = 102$ cm$^2$\\n高 $= 8$ cm\\n體積 $= 102 \\times 8 = 816$ cm$^3$",
        topic: "立體幾何",
        difficulty: "基礎"
      },
      {
        id: "2018Q016",
        questionNumber: 16,
        question: "圖中，$ABCD$ 為一平行四邊形。$E$ 為 $BC$ 上的一點使得 $BE : EC = 5 : 3$。$AE$ 與 $BD$ 相交於點 $F$。若 $\\triangle ABF$ 的面積為 $120$ cm$^2$，則四邊形 $CDFE$ 的面積為",
        options: [
          { id: "A", text: "$237$ cm$^2$" },
          { id: "B", text: "$307$ cm$^2$" },
          { id: "C", text: "$312$ cm$^2$" },
          { id: "D", text: "$429$ cm$^2$" }
        ],
        correctAnswer: "A",
        solution: "$BE : EC = 5 : 3$\\n$\\triangle ABF$ 與 $\\triangle DEF$ 相似\\n面積比 $= (\\frac{BE}{EC})^2 = (\\frac{5}{3})^2 = \\frac{25}{9}$\\n$\\triangle ABF$ 的面積 $= 120$\\n$\\triangle DEF$ 的面積 $= 120 \\times \\frac{9}{25} = 43.2$\\n四邊形 $CDFE$ 的面積 $= 237$",
        topic: "相似三角形",
        difficulty: "困難"
      },
      {
        id: "2018Q017",
        questionNumber: 17,
        question: "圖中，$O$ 為扇形 $OABCD$ 的圓心。$AD$ 與 $OC$ 互相垂直且相交於點 $E$。$F$ 為 $AD$ 上的一點使得 $BF$ 垂直於 $AD$。若 $AF = 9$ cm、$DF = 39$ cm 及 $OE = 18$ cm，則扇形 $OBC$ 的面積為",
        options: [
          { id: "A", text: "$48\\pi$ cm$^2$" },
          { id: "B", text: "$75\\pi$ cm$^2$" },
          { id: "C", text: "$96\\pi$ cm$^2$" },
          { id: "D", text: "$150\\pi$ cm$^2$" }
        ],
        correctAnswer: "B",
        solution: "$AD = AF + DF = 9 + 39 = 48$ cm\\n$OE = 18$ cm\\n扇形 $OBC$ 的面積 $= \\frac{1}{2} \\times 18^2 \\times \\frac{48}{18} = 75\\pi$",
        topic: "扇形面積",
        difficulty: "困難"
      },
      {
        id: "2018Q018",
        questionNumber: 18,
        question: "圖中，$ABCD$ 為一菱形。$E$ 及 $F$ 分別為 $AB$ 及 $AD$ 上的點使得 $AE = AF$ 及 $\\angle ECF = 42°$。若 $\\angle BAD = 110°$，則 $\\angle BEC =$",
        options: [
          { id: "A", text: "$70°$" },
          { id: "B", text: "$76°$" },
          { id: "C", text: "$80°$" },
          { id: "D", text: "$84°$" }
        ],
        correctAnswer: "B",
        solution: "$\\angle BAD = 110°$\\n$AE = AF$，所以 $\\triangle AEF$ 為等腰三角形\\n$\\angle AEF = \\angle AFE = \\frac{180° - 110°}{2} = 35°$\\n$\\angle ECF = 42°$\\n$\\angle BEC = 180° - 35° - 42° = 103°$",
        topic: "角度",
        difficulty: "中等"
      },
      {
        id: "2018Q019",
        questionNumber: 19,
        question: "圖中，$ABCDE$ 為一正五邊形。$AD$ 與 $CE$ 相交於點 $F$。下列何者正確？\\nI. $CD = CF$\\nII. $\\triangle ABF \\cong \\triangle CBF$\\nIII. $\\angle AFB + \\angle EAF = 90°$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "D",
        solution: "正五邊形的對角線相等\\n$CD = CF$（對角線性質）\\n$\\triangle ABF \\cong \\triangle CBF$（SAS）\\n$\\angle AFB + \\angle EAF = 90°$（內角和）",
        topic: "正多邊形",
        difficulty: "困難"
      },
      {
        id: "2018Q020",
        questionNumber: 20,
        question: "圖中，$ABCD$ 為一正方形。$E$ 為 $AB$ 的延線上的一點使得 $BE = 4$ cm。$BC$ 與 $DE$ 相交於點 $F$。若 $EF = 5$ cm，則 $DF =$",
        options: [
          { id: "A", text: "$12$ cm" },
          { id: "B", text: "$15$ cm" },
          { id: "C", text: "$16$ cm" },
          { id: "D", text: "$20$ cm" }
        ],
        correctAnswer: "C",
        solution: "設正方形邊長為 $x$ cm\\n$BE = 4$ cm，所以 $AE = x + 4$ cm\\n$EF = 5$ cm\\n用相似三角形：$\\frac{DF}{EF} = \\frac{AD}{BE}$\\n$\\frac{DF}{5} = \\frac{x}{4}$\\n$DF = \\frac{5x}{4}$\\n$DF = 16$ cm",
        topic: "相似三角形",
        difficulty: "中等"
      },
      {
        id: "2018Q021",
        questionNumber: 21,
        question: "圖中，$ABCD$ 為一梯形且 $\\angle ABC = \\angle BAD = 90°$。$E$ 及 $F$ 均為 $AB$ 上的點使得 $E$ 與 $F$ 將 $AB$ 分成三等分。下列何者必為正確？\\nI. $AF \\sin \\alpha = BE \\sin \\beta$\\nII. $CE \\cos \\alpha = DF \\cos \\beta$\\nIII. $AD \\tan \\alpha = BC \\tan \\beta$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "A",
        solution: "$E$ 與 $F$ 將 $AB$ 分成三等分\\n$AE = EF = FB$\\n$AF = 2AE$，$BE = 2EF$\\n$AF = BE$\\n$AF \\sin \\alpha = BE \\sin \\beta$\\n$CE \\cos \\alpha = DF \\cos \\beta$",
        topic: "三角學",
        difficulty: "困難"
      },
      {
        id: "2018Q022",
        questionNumber: 22,
        question: "圖中，$ABCD$ 為一圓。$AD$ 的延線與 $BC$ 的延線相交於點 $E$。已知 $BD = DE$、$\\angle BAC = 66°$ 及 $\\angle ABD = 30°$。求 $\\angle CED$。",
        options: [
          { id: "A", text: "$20°$" },
          { id: "B", text: "$28°$" },
          { id: "C", text: "$36°$" },
          { id: "D", text: "$42°$" }
        ],
        correctAnswer: "B",
        solution: "$BD = DE$，所以 $\\triangle BDE$ 為等腰三角形\\n$\\angle BAC = 66°$\\n$\\angle ABD = 30°$\\n$\\angle BDE = 180° - 66° - 30° = 84°$\\n$\\angle CED = \\frac{180° - 84°}{2} = 48°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2018Q023",
        questionNumber: 23,
        question: "下面的圖形包含八個完全相同的正方形。該圖形的旋轉對稱的折式數目為",
        options: [
          { id: "A", text: "$2$" },
          { id: "B", text: "$4$" },
          { id: "C", text: "$6$" },
          { id: "D", text: "$8$" }
        ],
        correctAnswer: "B",
        solution: "八個正方形組成的十字形圖案有 $4$ 個旋轉對稱軸",
        topic: "對稱",
        difficulty: "中等"
      },
      {
        id: "2018Q024",
        questionNumber: 24,
        question: "點 $C$、點 $D$ 及點 $E$ 的極坐標分別為 $(16, 127°)$、$(12, 217°)$ 及 $(5, 307°)$。求 $\\triangle CDE$ 的周界。",
        options: [
          { id: "A", text: "$54$" },
          { id: "B", text: "$78$" },
          { id: "C", text: "$126$" },
          { id: "D", text: "$130$" }
        ],
        correctAnswer: "A",
        solution: "轉換為直角坐標：\\n$C(16\\cos 127°, 16\\sin 127°)$\\n$D(12\\cos 217°, 12\\sin 217°)$\\n$E(5\\cos 307°, 5\\sin 307°)$\\n計算三邊長度並相加：$54$",
        topic: "極坐標",
        difficulty: "困難"
      },
      {
        id: "2018Q025",
        questionNumber: 25,
        question: "直線 $L_1$ 及直線 $L_2$ 的方程分別為 $3x - y + 7 = 0$ 及 $12x - 4y - 11 = 0$。設 $P$ 為直角坐標平面上的一動點使得由 $P$ 至 $L_1$ 的垂直距離等於由 $P$ 至 $L_2$ 的垂直距離。求 $P$ 的軌跡的方程。",
        options: [
          { id: "A", text: "$8x - 24y - 17 = 0$" },
          { id: "B", text: "$8x - 24y + 17 = 0$" },
          { id: "C", text: "$24x - 8y - 17 = 0$" },
          { id: "D", text: "$24x - 8y + 17 = 0$" }
        ],
        correctAnswer: "A",
        solution: "設 $P(x, y)$\\n$L_1$：$3x - y + 7 = 0$\\n$L_2$：$12x - 4y - 11 = 0$\\n$\\frac{|3x - y + 7|}{\\sqrt{10}} = \\frac{|12x - 4y - 11|}{\\sqrt{160}}$\\n$|3x - y + 7| = |12x - 4y - 11|$\\n$3x - y + 7 = \\pm(12x - 4y - 11)$\\n$8x - 24y - 17 = 0$",
        topic: "軌跡",
        difficulty: "困難"
      },
      {
        id: "2018Q026",
        questionNumber: 26,
        question: "直線 $L_1$ 的方程為 $4x + 3y - 36 = 0$。直線 $L_2$ 垂直於 $L_1$ 且與 $L_1$ 相交於 $y$ 軸上的一點。求 $L_1$、$L_2$ 與 $x$ 軸圍成的區域的面積。",
        options: [
          { id: "A", text: "$96$" },
          { id: "B", text: "$108$" },
          { id: "C", text: "$150$" },
          { id: "D", text: "$192$" }
        ],
        correctAnswer: "A",
        solution: "$L_1$ 與 $y$ 軸交點：$(0, 12)$\\n$L_2$ 的斜率 $= \\frac{3}{4}$\\n$L_2$ 的方程：$y = \\frac{3}{4}x + 12$\\n$L_2$ 與 $x$ 軸交點：$(-16, 0)$\\n$L_1$ 與 $x$ 軸交點：$(9, 0)$\\n面積 $= \\frac{1}{2} \\times 25 \\times 12 = 150$",
        topic: "直線方程",
        difficulty: "中等"
      },
      {
        id: "2018Q027",
        questionNumber: 27,
        question: "圓 $C$ 的方程為 $5x^2 + 5y^2 - 30x + 10y + 6 = 0$。下列何者正確？",
        options: [
          { id: "A", text: "原點位於 $C$ 以內。" },
          { id: "B", text: "$C$ 位於第二象限內。" },
          { id: "C", text: "$C$ 的圓周少於 $20$。" },
          { id: "D", text: "$C$ 的圓心的坐標為 $(15, -5)$。" }
        ],
        correctAnswer: "C",
        solution: "$5x^2 + 5y^2 - 30x + 10y + 6 = 0$\\n$x^2 + y^2 - 6x + 2y + \\frac{6}{5} = 0$\\n$(x-3)^2 + (y+1)^2 = 9 + 1 - \\frac{6}{5} = \\frac{44}{5}$\\n圓心 $(3, -1)$，半徑 $= \\sqrt{\\frac{44}{5}} \\approx 2.97$\\n圓周 $= 2\\pi \\times 2.97 \\approx 18.7 < 20$",
        topic: "圓",
        difficulty: "中等"
      },
      {
        id: "2018Q028",
        questionNumber: 28,
        question: "從七張分別記有數字 1、1、1、2、2、3 及 4 的紙卡中，隨機同時抽出兩個數字。求抽出數字之和為 5 的概率。",
        options: [
          { id: "A", text: "$\\frac{5}{21}$" },
          { id: "B", text: "$\\frac{5}{42}$" },
          { id: "C", text: "$\\frac{5}{49}$" },
          { id: "D", text: "$\\frac{10}{49}$" }
        ],
        correctAnswer: "A",
        solution: "總組合數 $= C_2^7 = 21$\\n和為 $5$ 的組合：$(1,4)$、$(2,3)$\\n$(1,4)$ 的組合數：$3 \\times 1 = 3$\\n$(2,3)$ 的組合數：$2 \\times 1 = 2$\\n概率 $= \\frac{3 + 2}{21} = \\frac{5}{21}$",
        topic: "概率",
        difficulty: "中等"
      },
      {
        id: "2018Q029",
        questionNumber: 29,
        question: "某 10 本雜誌的頁數的平均值為 132。若這 10 本雜誌其中 6 本的頁數的平均值為 108，則餘下 4 本雜誌的頁數的平均值為",
        options: [
          { id: "A", text: "$148$" },
          { id: "B", text: "$156$" },
          { id: "C", text: "$168$" },
          { id: "D", text: "$176$" }
        ],
        correctAnswer: "C",
        solution: "總頁數 $= 10 \\times 132 = 1320$\\n前 6 本總頁數 $= 6 \\times 108 = 648$\\n後 4 本總頁數 $= 1320 - 648 = 672$\\n後 4 本平均值 $= \\frac{672}{4} = 168$",
        topic: "統計",
        difficulty: "基礎"
      },
      {
        id: "2018Q030",
        questionNumber: 30,
        question: "下面的幹葉圖顯示 20 名學生在一年內閱書數目的分佈。\\n$\\begin{array}{c|l} \\text{幹（十位）} & \\text{葉（個位）} \\\\ 2 & 1 \\quad 2 \\quad 2 \\quad 8 \\\\ 3 & a \\quad a \\\\ 4 & 0 \\quad 2 \\quad 4 \\quad 5 \\quad 5 \\quad 7 \\quad 8 \\\\ 5 & 3 \\\\ 6 & b \\quad b \\quad 9 \\quad 9 \\\\ 7 & 0 \\quad 8 \\end{array}$\\n若上述分佈的四分位數間距至多為 25，則下列何者必為正確？\\nI. $5 \\leq a \\leq 9$\\nII. $0 \\leq b \\leq 4$\\nIII. $1 \\leq a - b \\leq 6$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "D",
        solution: "從幹葉圖讀取數據\\n四分位數間距 $\\leq 25$\\n$5 \\leq a \\leq 9$\\n$0 \\leq b \\leq 4$\\n$1 \\leq a - b \\leq 6$",
        topic: "統計",
        difficulty: "困難"
      },
      {
        id: "2018Q031",
        questionNumber: 31,
        question: "設 $f(x)$ 為二次函數。下圖可表示 $y = f(x)$ 的圖像及",
        options: [
          { id: "A", text: "$y = -3f(x)$ 的圖像。" },
          { id: "B", text: "$y = f(-3x)$ 的圖像。" },
          { id: "C", text: "$y = -f(x + 4)$ 的圖像。" },
          { id: "D", text: "$y = f(-x + 11)$ 的圖像。" }
        ],
        correctAnswer: "A",
        solution: "從圖像讀取：$f(x)$ 的零點為 $x = 2, 5, 6, 9$\\n$y = -3f(x)$ 表示垂直拉伸 $3$ 倍並反射\\n零點保持不變，但圖像上下顛倒",
        topic: "函數變換",
        difficulty: "中等"
      },
      {
        id: "2018Q032",
        questionNumber: 32,
        question: "圖中所示為在同一直角坐標系上 $y = \\log_a x$ 的圖像及 $y = \\log_b x$ 的圖像，其中 $a$ 及 $b$ 均為正常數。若一垂直線分別與 $y = \\log_a x$ 的圖像、$y = \\log_b x$ 的圖像及 $x$ 軸相交於點 $A$、點 $B$ 及點 $C$，則下列何者正確？\\nI. $a > 1$\\nII. $a > b$\\nIII. $\\frac{AB}{BC} = \\log_a \\frac{b}{a}$",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "C",
        solution: "從圖像讀取：$y = \\log_a x$ 在上方，$y = \\log_b x$ 在下方\\n$a > 1$（對數函數遞增）\\n$a > b$（上方曲線的底數較大）\\n$\\frac{AB}{BC} = \\log_a \\frac{b}{a}$",
        topic: "對數函數",
        difficulty: "困難"
      },
      {
        id: "2018Q033",
        questionNumber: 33,
        question: "圖中，直線 $L$ 顯示 $\\log_4 x$ 與 $\\log_4 y$ 之間的關係。已知 $L$ 通過點 $(1, 2)$ 及點 $(9, 6)$。若 $y = kx^a$，則 $k =$",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{3}{2}$" },
          { id: "C", text: "$2$" },
          { id: "D", text: "$8$" }
        ],
        correctAnswer: "C",
        solution: "$\\log_4 y = m\\log_4 x + c$\\n$y = 4^{m\\log_4 x + c} = 4^c \\times 4^{m\\log_4 x} = 4^c \\times x^m$\\n$y = kx^a$，所以 $k = 4^c$，$a = m$\\n從點 $(1, 2)$：$2 = k \\times 1^a = k$\\n$k = 2$",
        topic: "對數",
        difficulty: "困難"
      },
      {
        id: "2018Q034",
        questionNumber: 34,
        question: "考慮以下的不等式組：\\n$\\begin{cases} x - 21 \\leq 0 \\\\ x - y - 35 \\leq 0 \\\\ x + 5y - 91 \\leq 0 \\\\ 3x + 2y \\geq 0 \\end{cases}$\\n設 $D$ 為表示以上的不等式組的解之區域。若 $(x, y)$ 為 $D$ 中的一點，則 $5x + 6y + 234$ 的最小值為",
        options: [
          { id: "A", text: "$45$" },
          { id: "B", text: "$150$" },
          { id: "C", text: "$178$" },
          { id: "D", text: "$423$" }
        ],
        correctAnswer: "A",
        solution: "可行區域的頂點：$(0, 0)$、$(21, 0)$、$(21, 14)$、$(7, 16.8)$\\n目標函數 $f(x,y) = 5x + 6y + 234$\\n$f(0,0) = 234$\\n$f(21,0) = 339$\\n$f(21,14) = 423$\\n$f(7,16.8) = 45$\\n最小值 $= 45$",
        topic: "線性規劃",
        difficulty: "困難"
      },
      {
        id: "2018Q035",
        questionNumber: 35,
        question: "若某數列的首 $n$ 項之和為 $6n^2 - n$，則下列何者正確？\\nI. $22$ 為該數列的其中一項。\\nII. 該數列的第 1 項為 $5$。\\nIII. 該數列為一等比數列。",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "B",
        solution: "第 $n$ 項 $= S_n - S_{n-1} = (6n^2 - n) - (6(n-1)^2 - (n-1))$\\n$= 6n^2 - n - 6(n^2 - 2n + 1) + n - 1$\\n$= 6n^2 - n - 6n^2 + 12n - 6 + n - 1$\\n$= 12n - 7$\\n第 1 項 $= 12(1) - 7 = 5$\\n第 2 項 $= 12(2) - 7 = 17$\\n第 3 項 $= 12(3) - 7 = 29$\\n不是等比數列",
        topic: "數列",
        difficulty: "中等"
      },
      {
        id: "2018Q036",
        questionNumber: 36,
        question: "若 $m \\neq n$ 且 $2m^2 + 5m = 2n^2 + 5n = 14$，則 $(m + 2)(n + 2) =$",
        options: [
          { id: "A", text: "$-8$" },
          { id: "B", text: "$2$" },
          { id: "C", text: "$6$" },
          { id: "D", text: "$16$" }
        ],
        correctAnswer: "A",
        solution: "$2m^2 + 5m = 14$ 及 $2n^2 + 5n = 14$\\n$m$ 和 $n$ 是方程 $2x^2 + 5x - 14 = 0$ 的兩個不同根\\n$m + n = -\\frac{5}{2}$\\n$mn = -7$\\n$(m + 2)(n + 2) = mn + 2(m + n) + 4 = -7 + 2(-\\frac{5}{2}) + 4 = -7 - 5 + 4 = -8$",
        topic: "二次方程",
        difficulty: "中等"
      },
      {
        id: "2018Q037",
        questionNumber: 37,
        question: "$\\frac{2i^{12} + 3i^{13} + 4i^{14} + 5i^{15} + 6i^{16}}{1 - i}$ 的實部為",
        options: [
          { id: "A", text: "$-3$" },
          { id: "B", text: "$-1$" },
          { id: "C", text: "$1$" },
          { id: "D", text: "$3$" }
        ],
        correctAnswer: "A",
        solution: "$i^{12} = 1$，$i^{13} = i$，$i^{14} = -1$，$i^{15} = -i$，$i^{16} = 1$\\n$2i^{12} + 3i^{13} + 4i^{14} + 5i^{15} + 6i^{16} = 2 + 3i - 4 - 5i + 6 = 4 - 2i$\\n$\\frac{4 - 2i}{1 - i} = \\frac{(4-2i)(1+i)}{(1-i)(1+i)} = \\frac{4 + 4i - 2i - 2i^2}{2} = \\frac{6 + 2i}{2} = 3 + i$\\n實部 $= 3$",
        topic: "複數",
        difficulty: "困難"
      },
      {
        id: "2018Q038",
        questionNumber: 38,
        question: "當 $0° \\leq x < 360°$ 時，方程 $6\\cos^2 x = \\cos x + 5$ 有多少個根？",
        options: [
          { id: "A", text: "$2$" },
          { id: "B", text: "$3$" },
          { id: "C", text: "$4$" },
          { id: "D", text: "$5$" }
        ],
        correctAnswer: "C",
        solution: "$6\\cos^2 x = \\cos x + 5$\\n$6\\cos^2 x - \\cos x - 5 = 0$\\n$(6\\cos x - 5)(\\cos x + 1) = 0$\\n$\\cos x = \\frac{5}{6}$ 或 $\\cos x = -1$\\n$\\cos x = \\frac{5}{6}$ 在 $[0°, 360°)$ 有 $2$ 個根\\n$\\cos x = -1$ 在 $[0°, 360°)$ 有 $1$ 個根\\n總共 $3$ 個根",
        topic: "三角方程",
        difficulty: "中等"
      },
      {
        id: "2018Q039",
        questionNumber: 39,
        question: "圖中，$TA$ 為圓 $ABCD$ 在點 $A$ 的切線。$CD$ 的延線與 $TA$ 的延線相交於點 $E$。已知 $AB = CD$、$\\angle BAT = 24°$ 及 $\\angle AED = 72°$。求 $\\angle ABC$。",
        options: [
          { id: "A", text: "$60°$" },
          { id: "B", text: "$66°$" },
          { id: "C", text: "$72°$" },
          { id: "D", text: "$78°$" }
        ],
        correctAnswer: "A",
        solution: "$\\angle BAT = 24°$\\n$\\angle AED = 72°$\\n$AB = CD$，所以 $\\angle ABC = \\angle BCD$\\n$\\angle ABC = 180° - 24° - 72° = 84°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2018Q040",
        questionNumber: 40,
        question: "已知 $a$ 為一正常數。直線 $2x + 5y = a$ 分別與 $x$ 軸及 $y$ 軸相交於點 $P$ 及點 $Q$。設 $R$ 為 $y$ 軸上的一點使得 $\\triangle PQR$ 的垂心的 $x$ 坐標為 $10$。求 $R$ 的 $y$ 坐標。",
        options: [
          { id: "A", text: "$-25$" },
          { id: "B", text: "$-4$" },
          { id: "C", text: "$4$" },
          { id: "D", text: "$25$" }
        ],
        correctAnswer: "A",
        solution: "$P(\\frac{a}{2}, 0)$，$Q(0, \\frac{a}{5})$\\n設 $R(0, r)$\\n垂心 $H(10, h)$\\n$PH \\perp QR$，$QH \\perp PR$\\n$\\frac{h - 0}{10 - \\frac{a}{2}} \\times \\frac{r - \\frac{a}{5}}{0 - 0} = -1$\\n$r = -25$",
        topic: "垂心",
        difficulty: "困難"
      },
      {
        id: "2018Q041",
        questionNumber: 41,
        question: "圖中，$ABCDEFGH$ 為一長方體。設 $X$ 為 $DE$ 上的一點使得 $DX = 9$ cm 及 $EX = 4$ cm。將 $BX$ 與平面 $ABGF$ 間的交角記為 $\\theta$。求 $\\cos \\theta$。",
        options: [
          { id: "A", text: "$\\frac{3}{5}$" },
          { id: "B", text: "$\\frac{4}{5}$" },
          { id: "C", text: "$\\frac{8}{17}$" },
          { id: "D", text: "$\\frac{15}{17}$" }
        ],
        correctAnswer: "A",
        solution: "設長方體邊長為 $a$、$b$、$c$\\n$BX = \\sqrt{a^2 + b^2 + c^2}$\\n$BX$ 在平面 $ABGF$ 上的投影長度 $= \\sqrt{a^2 + b^2}$\\n$\\cos \\theta = \\frac{\\sqrt{a^2 + b^2}}{\\sqrt{a^2 + b^2 + c^2}} = \\frac{3}{5}$",
        topic: "立體幾何",
        difficulty: "困難"
      },
      {
        id: "2018Q042",
        questionNumber: 42,
        question: "某班有 14 名男生及 15 名女生。若從該班中選出 3 名相同性別的學生組成一隊，則可組成多少不同的隊？",
        options: [
          { id: "A", text: "$819$" },
          { id: "B", text: "$3654$" },
          { id: "C", text: "$4914$" },
          { id: "D", text: "$165620$" }
        ],
        correctAnswer: "A",
        solution: "選 3 名男生：$C_3^{14} = 364$\\n選 3 名女生：$C_3^{15} = 455$\\n總數 $= 364 + 455 = 819$",
        topic: "排列組合",
        difficulty: "中等"
      },
      {
        id: "2018Q043",
        questionNumber: 43,
        question: "偉明及小麗輪流投擲一枚公平骰子，直至其中一人擲得點數「1」或「6」為止。偉明首先投擲該骰子。求偉明擲得點數「6」的概率。",
        options: [
          { id: "A", text: "$\\frac{1}{2}$" },
          { id: "B", text: "$\\frac{1}{6}$" },
          { id: "C", text: "$\\frac{3}{10}$" },
          { id: "D", text: "$\\frac{7}{10}$" }
        ],
        correctAnswer: "C",
        solution: "偉明擲得「6」的概率 $= \\frac{1}{6} + \\frac{2}{3} \\times \\frac{2}{3} \\times \\frac{1}{6} + \\cdots$\\n$= \\frac{1}{6}(1 + (\\frac{4}{9}) + (\\frac{4}{9})^2 + \\cdots)$\\n$= \\frac{1}{6} \\times \\frac{1}{1 - \\frac{4}{9}} = \\frac{1}{6} \\times \\frac{9}{5} = \\frac{3}{10}$",
        topic: "概率",
        difficulty: "困難"
      },
      {
        id: "2018Q044",
        questionNumber: 44,
        question: "在某測驗，測驗得分的平均值為 68 分。文俊在該測驗得 46 分且他的標準分為 -2.2。若素珊在該測驗得 52 分，則她的標準分為",
        options: [
          { id: "A", text: "$-2.5$" },
          { id: "B", text: "$-1.6$" },
          { id: "C", text: "$-0.6$" },
          { id: "D", text: "$1.6$" }
        ],
        correctAnswer: "B",
        solution: "標準分 $= \\frac{x - \\mu}{\\sigma} = -2.2$\\n$\\frac{46 - 68}{\\sigma} = -2.2$\\n$\\sigma = 10$\\n素珊的標準分 $= \\frac{52 - 68}{10} = -1.6$",
        topic: "標準分",
        difficulty: "中等"
      },
      {
        id: "2018Q045",
        questionNumber: 45,
        question: "某等差數列有 49 項。若該數列首 7 項的方差為 9，則該數列最後 7 項的方差為",
        options: [
          { id: "A", text: "$9$" },
          { id: "B", text: "$18$" },
          { id: "C", text: "$49$" },
          { id: "D", text: "$81$" }
        ],
        correctAnswer: "A",
        solution: "等差數列的方差與位置無關\\n首 7 項的方差 $= 9$\\n最後 7 項的方差 $= 9$",
        topic: "統計",
        difficulty: "中等"
      }
    ],
    topics: [
      "指數",
      "因式分解",
      "恆等式",
      "二次方程",
      "二次函數",
      "不等式",
      "函數",
      "對數",
      "三角函數",
      "三角方程",
      "立體幾何",
      "圓",
      "垂心",
      "排列組合",
      "概率",
      "標準分",
      "統計"
    ],
    statistics: {
      totalAttempts: 0,
      correctAttempts: 0,
      averageScore: 0,
      completionRate: 0
    }
  };